/* eslint-disable prettier/prettier */
// src/modules/owner/pages/actions/tanqueCheio/components/PostosConfigModal.jsx
import React, { useState, useEffect, useCallback, useRef, memo } from 'react';
import InputMask from 'react-input-mask';
import axios from 'axios';
import { connect } from 'react-redux';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Typography,
  Tabs,
  Tab,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Table as MuiTable,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  InputAdornment,
  Card,
  CardContent,
  Grid,
  Autocomplete,
  Collapse,
  Avatar,
  Chip,
} from '@mui/material';
import { Edit, Delete, Autorenew, LocalGasStation, Close, ExpandMore, ExpandLess, Group } from '@mui/icons-material';
import PrimaryButton from 'common/components/buttons/primaryButton';
import SecondaryButton from 'common/components/buttons/secondaryButton';
import { BASE_API, USER_TOKEN } from 'config/consts';
import { FuelInputContainer, FuelInputLabel, FuelInputField, FuelInputSuffix } from './styles';

const ESTADOS_BRASILEIROS = [
  { sigla: 'AC', nome: 'Acre' },
  { sigla: 'AL', nome: 'Alagoas' },
  { sigla: 'AP', nome: 'Amapá' },
  { sigla: 'AM', nome: 'Amazonas' },
  { sigla: 'BA', nome: 'Bahia' },
  { sigla: 'CE', nome: 'Ceará' },
  { sigla: 'DF', nome: 'Distrito Federal' },
  { sigla: 'ES', nome: 'Espírito Santo' },
  { sigla: 'GO', nome: 'Goiás' },
  { sigla: 'MA', nome: 'Maranhão' },
  { sigla: 'MT', nome: 'Mato Grosso' },
  { sigla: 'MS', nome: 'Mato Grosso do Sul' },
  { sigla: 'MG', nome: 'Minas Gerais' },
  { sigla: 'PA', nome: 'Pará' },
  { sigla: 'PB', nome: 'Paraíba' },
  { sigla: 'PR', nome: 'Paraná' },
  { sigla: 'PE', nome: 'Pernambuco' },
  { sigla: 'PI', nome: 'Piauí' },
  { sigla: 'RJ', nome: 'Rio de Janeiro' },
  { sigla: 'RN', nome: 'Rio Grande do Norte' },
  { sigla: 'RS', nome: 'Rio Grande do Sul' },
  { sigla: 'RO', nome: 'Rondônia' },
  { sigla: 'RR', nome: 'Roraima' },
  { sigla: 'SC', nome: 'Santa Catarina' },
  { sigla: 'SP', nome: 'São Paulo' },
  { sigla: 'SE', nome: 'Sergipe' },
  { sigla: 'TO', nome: 'Tocantins' },
];

const FuelInput = memo(({ stationId, fuel, initialValue, onChange }) => {
  const inputRef = useRef(null);
  
  const handleInput = (e) => {
    let v = e.target.value.replace(/,/g, '.');
    v = v.replace(/[^0-9.]/g, '');
    
    const parts = v.split('.');
    if (parts[0].length > 10) {
      parts[0] = parts[0].substring(0, 10);
    }
    
    if (parts[1] && parts[1].length > 2) {
      parts[1] = parts[1].substring(0, 2);
    }

    v = parts.length > 1 ? parts[0] + '.' + parts[1] : parts[0];
    
    if ((v.match(/\./g) || []).length > 1) {
      const cleanParts = v.split('.');
      v = cleanParts[0] + '.' + cleanParts.slice(1).join('');
    }

    if (e.target.value !== v) {
      e.target.value = v;
    }
  };
  
  const handleBlur = (e) => {
    let v = e.target.value;
    
    const numValue = parseFloat(v);
    if (numValue > 9999999999.99) {
      v = '9999999999.99';
      e.target.value = v;
    }
    
    onChange(stationId, fuel.id, v);
  };

  return (
    <FuelInputContainer>
      <FuelInputLabel>
        {fuel.icon} {fuel.name}
      </FuelInputLabel>
      <FuelInputField
        ref={inputRef}
        type="text"
        defaultValue={initialValue || ''}
        onInput={handleInput}
        inputMode="decimal"
        pattern="[0-9.,]*"
        placeholder="0.00"
        maxLength="13"
        onBlur={handleBlur}
      />
      <FuelInputSuffix>
        L
      </FuelInputSuffix>
    </FuelInputContainer>
  );
});

FuelInput.displayName = 'FuelInput';

const PostosConfigModal = ({ open, onClose, tabValue, onTabChange, dispatch }) => {
  // ——— Postos ———
  const [posts, setPosts] = useState([]);
  const [addPostOpen, setAddPostOpen] = useState(false);
  const [editingPostIndex, setEditingPostIndex] = useState(null);
  const [postName, setPostName] = useState('');
  const [postGroup, setPostGroup] = useState('');
  const [postNetwork, setPostNetwork] = useState('');
  const [postCode, setPostCode] = useState('');
  const [postAddress, setPostAddress] = useState('');
  const [postCNPJ, setPostCNPJ] = useState('');
  const [postCity, setPostCity] = useState('');
  const [postState, setPostState] = useState('');

  // ——— Grupos de Postos ———
  const [groups, setGroups] = useState([]);
  const [addGroupOpen, setAddGroupOpen] = useState(false);
  const [editingGroupIndex, setEditingGroupIndex] = useState(null);
  const [newGroupName, setNewGroupName] = useState('');
  const [newGroupPosts, setNewGroupPosts] = useState([]);

  // ——— Redes ———
  const [networks, setNetworks] = useState([]);
  const [addNetworkOpen, setAddNetworkOpen] = useState(false);
  const [editingNetworkIndex, setEditingNetworkIndex] = useState(null);
  const [newNetworkName, setNewNetworkName] = useState('');

  // ——— Estoque ———
  const [stations, setStations] = useState([]);
  const [selectedStations, setSelectedStations] = useState([]);
  const [fuelStock, setFuelStock] = useState({});
  const [loading, setLoading] = useState(false);
  const [stationGroupings, setStationGroupings] = useState({}); // { stationId: [groupings] }
  const [expandedStations, setExpandedStations] = useState({}); // { stationId: boolean }
  const [expandedGroupings, setExpandedGroupings] = useState({}); // { groupingId: boolean }

  // Tipos de combustível
  const FUEL_TYPES = [
    { id: 'gasolina_comum', name: 'Gasolina Comum', icon: '⛽' },
    { id: 'gasolina_aditivada', name: 'Gasolina Aditivada', icon: '🔥' },
    { id: 'etanol', name: 'Etanol', icon: '🌱' },
    { id: 'diesel', name: 'Diesel', icon: '🚛' },
    { id: 'diesel_s10', name: 'Diesel S10', icon: '🚚' },
    { id: 'podium', name: 'Podium', icon: '🏆' },
  ];

  // Gera código validador aleatório de 6 caracteres
  const generateCode = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    return Array.from({ length: 6 })
      .map(() => chars.charAt(Math.floor(Math.random() * chars.length)))
      .join('');
  };

  const formatCNPJ = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 14);
    return digits
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2}\.\d{3})(\d)/, '$1.$2')
      .replace(/^(\d{2}\.\d{3}\.\d{3})(\d)/, '$1/$2')
      .replace(/^(\d{2}\.\d{3}\.\d{3}\/\d{4})(\d)/, '$1-$2');
  };

  // ——— Funções de Grupo ———
  const openAddGroup = () => {
    setEditingGroupIndex(null);
    setNewGroupName('');
    setNewGroupPosts([]);
    setAddGroupOpen(true);
  };
  const openEditGroup = (i) => {
    const grp = groups[i];
    setEditingGroupIndex(i);
    setNewGroupName(grp.name);
    setNewGroupPosts(grp.posts);
    setAddGroupOpen(true);
  };
  const deleteGroup = async (i) => {
    const group = groups[i];
    if (!group.id) {

      setGroups((prev) => prev.filter((_, idx) => idx !== i));
      return;
    }

    try {
      await axios.delete(`${BASE_API}/tanque-cheio/grupo-postos/${group.id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      });
      
      setGroups((prev) => prev.filter((_, idx) => idx !== i));
    } catch (error) {
      console.error('Erro ao deletar grupo:', error);
      const errorMessage = error.response?.data?.messages?.[0] || 'Erro ao deletar grupo';
      dispatch({ type: 'SNACKBAR', payload: { message: errorMessage, variant: 'error', open: true } });
    }
  };
  const confirmGroup = async () => {
    const name = newGroupName.trim();
    if (!name) return;
    
    try {
      const groupData = {
        nome: name,
        descricao: '',
        postos: newGroupPosts
      };

      let savedGroup;
      if (editingGroupIndex !== null) {
        const existingGroup = groups[editingGroupIndex];
        if (existingGroup.id) {
          const response = await axios.put(`${BASE_API}/tanque-cheio/grupo-postos/${existingGroup.id}`, groupData, {
            headers: {
              Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
            },
          });
          savedGroup = response.data.data;
        }
      } else {
        // Criar novo grupo
        const response = await axios.post(`${BASE_API}/tanque-cheio/grupo-postos`, groupData, {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        });
        savedGroup = response.data.data;
      }

      const entry = { 
        id: savedGroup?.id || groups[editingGroupIndex]?.id,
        name, 
        posts: newGroupPosts 
      };

      if (editingGroupIndex !== null) {
        setGroups((prev) =>
          prev.map((g, idx) => (idx === editingGroupIndex ? entry : g))
        );
      } else {
        setGroups((prev) => [...prev, entry]);
      }
      setAddGroupOpen(false);
    } catch (error) {
      console.error('Erro ao salvar grupo:', error);
      const errorMessage = error.response?.data?.messages?.[0] || 'Erro ao salvar grupo';
      dispatch({ type: 'SNACKBAR', payload: { message: errorMessage, variant: 'error', open: true } });
    }
  };

  const openAddNetwork = () => {
    setEditingNetworkIndex(null);
    setNewNetworkName('');
    setAddNetworkOpen(true);
  };
  const openEditNetwork = (i) => {
    setEditingNetworkIndex(i);
    setNewNetworkName(networks[i].name || networks[i]);
    setAddNetworkOpen(true);
  };
  const deleteNetwork = async (i) => {
    const network = networks[i];
    if (!network.id) {
      setNetworks((prev) => prev.filter((_, idx) => idx !== i));
      return;
    }

    try {
      await axios.delete(`${BASE_API}/tanque-cheio/redes/${network.id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      });
      
      setNetworks((prev) => prev.filter((_, idx) => idx !== i));
      if (dispatch) {
        dispatch({ type: 'SNACKBAR', payload: { message: 'Rede removida com sucesso!', variant: 'success', open: true } });
      }
    } catch (error) {
      console.error('Erro ao deletar rede:', error);
      const errorMessage = error.response?.data?.messages?.[0] || 'Erro ao deletar rede';
      if (dispatch) {
        dispatch({ type: 'SNACKBAR', payload: { message: errorMessage, variant: 'error', open: true } });
      }
    }
  };
  const confirmNetwork = async () => {
    const name = newNetworkName.trim();
    if (!name) {
      if (dispatch) {
        dispatch({ type: 'SNACKBAR', payload: { message: 'Nome da rede é obrigatório', variant: 'error', open: true } });
      }
      return;
    }
    
    try {
      const networkData = { nome: name };

      let savedNetwork;
      if (editingNetworkIndex !== null) {
        // Editar rede existente
        const existingNetwork = networks[editingNetworkIndex];
        if (existingNetwork.id) {
          const response = await axios.put(`${BASE_API}/tanque-cheio/redes/${existingNetwork.id}`, networkData, {
            headers: {
              Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
            },
          });
          savedNetwork = response.data.data || response.data;
        }
        setNetworks((prev) =>
          prev.map((n, idx) => (idx === editingNetworkIndex ? { id: savedNetwork?.id || n.id, name } : n))
        );
        if (dispatch) {
          dispatch({ type: 'SNACKBAR', payload: { message: 'Rede atualizada com sucesso!', variant: 'success', open: true } });
        }
      } else {
        // Criar nova rede
        const response = await axios.post(`${BASE_API}/tanque-cheio/redes`, networkData, {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        });
        savedNetwork = response.data.data || response.data;
        
        setNetworks((prev) => [...prev, { id: savedNetwork?.id, name }]);
        if (dispatch) {
          dispatch({ type: 'SNACKBAR', payload: { message: 'Rede criada com sucesso!', variant: 'success', open: true } });
        }
      }
      setAddNetworkOpen(false);
    } catch (error) {
      console.error('Erro ao salvar rede:', error);
      const errorMessage = error.response?.data?.messages?.[0] || 'Erro ao salvar rede';
      if (dispatch) {
        dispatch({ type: 'SNACKBAR', payload: { message: errorMessage, variant: 'error', open: true } });
      }
    }
  };

  // ——— Funções de Posto ———
  const openAddPost = () => {
    setEditingPostIndex(null);
    setPostName('');
    setPostGroup('');
    setPostNetwork('');
    setPostCode('');
    setPostAddress('');
    setPostCNPJ('');
    setPostCity('');
    setPostState('');
    setAddPostOpen(true);
  };
  const openEditPost = (i) => {
    const p = posts[i];
    setEditingPostIndex(i);
    setPostName(p.name || '');
    setPostGroup(p.group || '');
    setPostNetwork(p.network || '');
    setPostCode(p.code || '');
    setPostAddress(p.address || '');
    setPostCNPJ((p.cnpj || '').replace(/\D/g, ''));
    setPostCity(p.city || '');
    setPostState(p.state || '');
    setAddPostOpen(true);
  };
  const deletePost = async (i) => {
    const post = posts[i];
    if (!post.id) {
      // Se não tem ID, apenas remove da lista local
      setPosts((prev) => prev.filter((_, idx) => idx !== i));
      return;
    }

    try {
      await axios.delete(`${BASE_API}/tanque-cheio/config-postos/${post.id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      });
      
      setPosts((prev) => prev.filter((_, idx) => idx !== i));
    } catch (error) {
      console.error('Erro ao deletar posto:', error);
      const errorMessage = error.response?.data?.messages?.[0] || 'Erro ao deletar posto';
      dispatch({ type: 'SNACKBAR', payload: { message: errorMessage, variant: 'error', open: true } });
    }
  };

  // ——— Funções de Estoque ———
  const fetchStations = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${BASE_API}/stations`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      });
      setStations(response.data || []);
    } catch (error) {
      console.error('Erro ao buscar estações:', error);
    } finally {
      setLoading(false);
    }
  };

  // Buscar groupings de uma estação específica
  const fetchGroupingsForStation = async (stationId) => {
    if (stationGroupings[stationId]) return; // Já carregado
    try {
      const response = await axios.get(`${BASE_API}/groupings-list-table`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
        params: {
          station_id: stationId,
          active: true
        }
      });
      setStationGroupings(prev => ({
        ...prev,
        [stationId]: response.data || []
      }));
    } catch (error) {
      console.error('Erro ao buscar groupings:', error);
      setStationGroupings(prev => ({
        ...prev,
        [stationId]: []
      }));
    }
  };

  // Toggle expansão da estação (mostra/esconde groupings)
  const toggleStationExpand = (stationId) => {
    setExpandedStations(prev => ({
      ...prev,
      [stationId]: !prev[stationId]
    }));
    // Buscar groupings se ainda não carregados
    if (!stationGroupings[stationId]) {
      fetchGroupingsForStation(stationId);
    }
  };

  // Toggle expansão do grouping (mostra/esconde config de combustível)
  const toggleGroupingExpand = (groupingId) => {
    setExpandedGroupings(prev => ({
      ...prev,
      [groupingId]: !prev[groupingId]
    }));
  };

  // Handler para mudança de estoque de grouping
  const handleGroupingStockChange = useCallback((groupingId, fuelType, value) => {
    const key = `grouping_${groupingId}_${fuelType}`;
    setFuelStock(prev => {
      if (prev[key] === value) return prev;
      return {
        ...prev,
        [key]: value
      };
    });
  }, []);

  const handleStockChange = useCallback((stationId, fuelType, value) => {
    const key = `${stationId}_${fuelType}`;
    setFuelStock(prev => {
      if (prev[key] === value) return prev;
      return {
        ...prev,
        [key]: value
      };
    });
  }, []);

  const removeStation = (stationId) => {
    setSelectedStations(prev => prev.filter(id => id !== stationId));    
    setFuelStock(prev => {
      const newStock = { ...prev };
      FUEL_TYPES.forEach(fuel => {
        const key = `${stationId}_${fuel.id}`;
        delete newStock[key];
      });
      return newStock;
    });
  };

  const saveStockConfiguration = async () => {
    try {
      setLoading(true);
      
      const stockData = [];
      
      // Estoque das Stations
      selectedStations.forEach(stationId => {
        FUEL_TYPES.forEach(fuel => {
          const key = `${stationId}_${fuel.id}`;
          const quantity = fuelStock[key];
          if (quantity && quantity > 0) {
            stockData.push({
              station_id: stationId,
              fuel_type: fuel.id,
              quantity: parseFloat(quantity),
            });
          }
        });
      });

      // Estoque dos Groupings (separado das stations)
      Object.keys(fuelStock).forEach(key => {
        if (key.startsWith('grouping_')) {
          const parts = key.split('_');
          // key format: grouping_{groupingId}_{fuelType}
          const groupingId = parseInt(parts[1]);
          const fuelType = parts.slice(2).join('_'); // Para fuel types com underscore
          const quantity = fuelStock[key];
          
          if (quantity && quantity > 0) {
            stockData.push({
              grouping_id: groupingId,
              fuel_type: fuelType,
              quantity: parseFloat(quantity),
            });
          }
        }
      });

      await axios.post(`${BASE_API}/tanque-cheio/stock`, { stockData }, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      });

      dispatch({ type: 'SNACKBAR', payload: { message: 'Configuração de estoque salva com sucesso!', variant: 'success', open: true } });
    } catch (error) {
      console.error('Erro ao salvar configuração de estoque:', error);
      dispatch({ type: 'SNACKBAR', payload: { message: 'Erro ao salvar configuração de estoque', variant: 'error', open: true } });
    } finally {
      setLoading(false);
    }
  };

  const loadStockConfiguration = async () => {
    try {
      const response = await axios.get(`${BASE_API}/tanque-cheio/stock`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      });
      
      const stockData = {};
      const selectedStationIds = [];
      
      response.data.forEach(item => {
        if (item.grouping_id) {
          // Estoque de grouping
          const key = `grouping_${item.grouping_id}_${item.fuel_type}`;
          stockData[key] = item.quantity;
        } else if (item.station_id) {
          // Estoque de station
          const key = `${item.station_id}_${item.fuel_type}`;
          stockData[key] = item.quantity;
          if (!selectedStationIds.includes(item.station_id)) {
            selectedStationIds.push(item.station_id);
          }
        }
      });
      
      setFuelStock(stockData);
      setSelectedStations(selectedStationIds);
    } catch (error) {
      console.error('Erro ao carregar configuração de estoque:', error);
    }
  };

  const loadStockForSelectedStations = async () => {
    try {
      // Buscar estoque apenas das estações selecionadas
      const stationIds = selectedStations.join(',');
      const response = await axios.get(`${BASE_API}/tanque-cheio/stock?station_ids=${stationIds}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      });
      
      const stockData = { ...fuelStock };
      
      response.data.forEach(item => {
        const key = `${item.station_id}_${item.fuel_type}`;
        stockData[key] = item.quantity;
      });
      
      setFuelStock(stockData);
    } catch (error) {
      console.error('Erro ao carregar estoque das estações selecionadas:', error);
    }
  };

  useEffect(() => {
    if (open) {
      if (tabValue === 3) {
        fetchStations();
      }
      loadExistingData();
    }
  }, [open, tabValue]);

  // Carregar groupings automaticamente quando estações são selecionadas
  useEffect(() => {
    selectedStations.forEach(stationId => {
      if (!stationGroupings[stationId]) {
        fetchGroupingsForStation(stationId);
      }
    });
  }, [selectedStations]);

  const loadExistingData = async () => {
    try {
      const redesResponse = await axios.get(`${BASE_API}/tanque-cheio/redes`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      });
      setNetworks(redesResponse.data.map(rede => ({
        id: rede.id,
        name: rede.nome
      })));

      // Carregar postos
      const configResponse = await axios.get(`${BASE_API}/tanque-cheio/config-postos`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      });

      const postos = configResponse.data.filter(item => item.tipo === 'posto').map(posto => ({
        id: posto.id,
        name: posto.nome,
        group: posto.nome_grupo,
        network: posto.nome_rede,
        code: posto.codigo,
        address: posto.endereco,
        cnpj: posto.cnpj,
        city: posto.cidade,
        state: posto.estado
      }));

      // Carregar grupos da nova tabela TanqueCheioGrupoPostos
      const gruposResponse = await axios.get(`${BASE_API}/tanque-cheio/grupo-postos`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      });

      const grupos = gruposResponse.data.map(grupo => ({
        id: grupo.id,
        name: grupo.nome,
        posts: grupo.postos ? grupo.postos.map(posto => posto.nome) : []
      }));

      setPosts(postos);
      setGroups(grupos);
    } catch (error) {
      console.error('Erro ao carregar dados existentes:', error);
    }
  };

  // Carregar dados de estoque quando estações forem selecionadas
  useEffect(() => {
    if (selectedStations.length > 0) {
      loadStockForSelectedStations();
    }
  }, [selectedStations]);

  const confirmPost = async () => {
    const name = postName.trim();
    if (!name || !postNetwork) {
      let errorMessage = 'Preencha os campos obrigatórios: Nome do Posto e Rede do Posto';
      if (!name) {
        errorMessage = 'Preencha o campo obrigatório: Nome do Posto';
      } else if (!postNetwork) {
        errorMessage = 'Preencha o campo obrigatório: Rede do Posto';
      }
      dispatch({ type: 'SNACKBAR', payload: { message: errorMessage, variant: 'error', open: true } });
      return;
    }
    
    const entry = {
      name,
      group: postGroup,
      network: postNetwork,
      code: postCode.trim(),
      address: postAddress.trim(),
      cnpj: formatCNPJ(postCNPJ),
      city: postCity.trim(),
      state: postState.trim(),
    };

    try {
      const postData = {
        tipo: 'posto',
        nome: entry.name,
        nome_grupo: entry.group,
        nome_rede: entry.network,
        codigo: entry.code,
        endereco: entry.address,
        cnpj: entry.cnpj,
        cidade: entry.city,
        estado: entry.state
      };

      let savedPost;
      if (editingPostIndex !== null) {
        // Editar posto existente
        const existingPost = posts[editingPostIndex];
        if (existingPost.id) {
          const response = await axios.put(`${BASE_API}/tanque-cheio/config-postos/${existingPost.id}`, postData, {
            headers: {
              Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
            },
          });
          savedPost = response.data.data;
        }
      } else {
        // Criar novo posto
        const response = await axios.post(`${BASE_API}/tanque-cheio/config-postos`, postData, {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        });
        savedPost = response.data.data;
      }

      // Adicionar ID ao entry
      entry.id = savedPost?.id || posts[editingPostIndex]?.id;

      if (editingPostIndex !== null) {
        // Edição de posto existente
        const old = posts[editingPostIndex];
        const oldName = old.name;
        const oldGroup = old.group;

        setPosts((prev) =>
          prev.map((p, idx) => (idx === editingPostIndex ? entry : p))
        );

        // Atualiza grupos: remove/renomeia do antigo, adiciona ao novo
        setGroups((prev) =>
          prev.map((g) => {
            if (g.name === oldGroup && oldGroup === entry.group) {
              return {
                ...g,
                posts: g.posts.map((pn) =>
                  pn === oldName ? entry.name : pn
                ),
              };
            } else if (g.name === oldGroup) {
              return {
                ...g,
                posts: g.posts.filter((pn) => pn !== oldName),
              };
            } else if (g.name === entry.group) {
              return {
                ...g,
                posts: g.posts.includes(entry.name)
                  ? g.posts
                  : [...g.posts, entry.name],
              };
            }
            return g;
          })
        );
      } else {
        // Novo posto
        setPosts((prev) => [...prev, entry]);
        // Adiciona automaticamente ao grupo
        setGroups((prev) =>
          prev.map((g) =>
            g.name === entry.group
              ? { ...g, posts: [...g.posts, entry.name] }
              : g
          )
        );
      }

      setAddPostOpen(false);
    } catch (error) {
      console.error('Erro ao salvar posto:', error);
      console.error('Detalhes do erro ao salvar posto:', error?.response?.data);
      const errorMessage =
        error?.response?.data?.messages?.[0] ||
        error?.response?.data?.message ||
        error?.message ||
        'Erro ao salvar posto';
      dispatch({ type: 'SNACKBAR', payload: { message: errorMessage, variant: 'error', open: true } });
    }
  };

  // Painel de abas
  const TabPanel = ({ children, value, index }) =>
    value === index ? <Box sx={{ py: 2 }}>{children}</Box> : null;

  return (
    <>
      {/* Modal principal */}
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <Box sx={{ p: 2 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Configuração de Postos
          </Typography>
          <Tabs
            value={tabValue}
            onChange={onTabChange}
            sx={{ borderBottom: 1, borderColor: 'divider' }}
          >
            <Tab label="POSTOS" />
            <Tab label="GRUPOS DE POSTOS" />
            <Tab label="REDES" />
            <Tab label="ESTOQUE" />
          </Tabs>

          {/* Aba de Postos */}
          <TabPanel value={tabValue} index={0}>
            <Box
              sx={{
                mb: 2,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography variant="h6">Gerenciar Postos</Typography>
              <PrimaryButton onClick={openAddPost}>
                Adicionar Posto
              </PrimaryButton>
            </Box>
            <MuiTable size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Nome</TableCell>
                  <TableCell>Grupo</TableCell>
                  <TableCell>Rede</TableCell>
                  <TableCell>Código</TableCell>
                  <TableCell>Endereço</TableCell>
                  <TableCell>CNPJ</TableCell>
                  <TableCell>Cidade/Estado</TableCell>
                  <TableCell align="right">Ações</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {posts.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center" sx={{ py: 4 }}>
                      Nenhum posto cadastrado
                    </TableCell>
                  </TableRow>
                ) : (
                  posts.map((p, i) => (
                    <TableRow key={i}>
                      <TableCell>{p.name}</TableCell>
                      <TableCell>{p.group}</TableCell>
                      <TableCell>{p.network}</TableCell>
                      <TableCell>{p.code}</TableCell>
                      <TableCell>{p.address}</TableCell>
                      <TableCell>{p.cnpj}</TableCell>
                      <TableCell>{`${p.city} / ${p.state}`}</TableCell>
                      <TableCell align="right">
                        <IconButton size="small" onClick={() => openEditPost(i)}>
                          <Edit fontSize="small" />
                        </IconButton>
                        <IconButton size="small" onClick={() => deletePost(i)}>
                          <Delete fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </MuiTable>
          </TabPanel>

          {/* Aba de Grupos de Postos */}
          <TabPanel value={tabValue} index={1}>
            <Box
              sx={{
                mb: 2,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography variant="h6">Gerenciar Grupos</Typography>
              <PrimaryButton onClick={openAddGroup}>
                Adicionar Grupo
              </PrimaryButton>
            </Box>
            <MuiTable size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Nome do Grupo</TableCell>
                  <TableCell>Postos</TableCell>
                  <TableCell align="right">Ações</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {groups.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={3} align="center" sx={{ py: 4 }}>
                      Nenhum grupo cadastrado
                    </TableCell>
                  </TableRow>
                ) : (
                  groups.map((g, i) => (
                    <TableRow key={i}>
                      <TableCell>{g.name}</TableCell>
                      <TableCell>
                        {g.posts.length > 0 ? g.posts.join(', ') : '—'}
                      </TableCell>
                      <TableCell align="right">
                        <IconButton size="small" onClick={() => openEditGroup(i)}>
                          <Edit fontSize="small" />
                        </IconButton>
                        <IconButton size="small" onClick={() => deleteGroup(i)}>
                          <Delete fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </MuiTable>
          </TabPanel>

          {/* Aba de Redes */}
          <TabPanel value={tabValue} index={2}>
            <Box
              sx={{
                mb: 2,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography variant="h6">Gerenciar Redes</Typography>
              <PrimaryButton onClick={openAddNetwork}>
                Adicionar Rede
              </PrimaryButton>
            </Box>
            <MuiTable size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Nome da Rede</TableCell>
                  <TableCell>Quantidade de Postos</TableCell>
                  <TableCell align="right">Ações</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {networks.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={3} align="center" sx={{ py: 4 }}>
                      Nenhuma rede cadastrada
                    </TableCell>
                  </TableRow>
                ) : (
                  networks.map((n, i) => (
                    <TableRow key={i}>
                      <TableCell>{n.name || n}</TableCell>
                      <TableCell>
                        {posts.filter((p) => p.network === (n.name || n)).length}
                      </TableCell>
                      <TableCell align="right">
                        <IconButton size="small" onClick={() => openEditNetwork(i)}>
                          <Edit fontSize="small" />
                        </IconButton>
                        <IconButton size="small" onClick={() => deleteNetwork(i)}>
                          <Delete fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </MuiTable>
          </TabPanel>

          {/* Aba de Estoque */}
          <TabPanel value={tabValue} index={3}>
            <Box
              sx={{
                mb: 2,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography variant="h6">Gerenciar Estoque de Combustível</Typography>
              <PrimaryButton onClick={saveStockConfiguration} disabled={loading}>
                {loading ? 'Salvando...' : 'Salvar Configuração'}
              </PrimaryButton>
            </Box>

            {/* Seleção de Estações */}
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 2 }}>
                  Selecionar Estações
                </Typography>
                <Autocomplete
                  multiple
                  options={stations}
                  getOptionLabel={(option) => `${option.name} (ID: ${option.id})`}
                  value={stations.filter(s => selectedStations.includes(s.id))}
                  onChange={(event, newValue) => {
                    setSelectedStations(newValue.map(s => s.id));
                  }}
                  disableCloseOnSelect
                  renderOption={(props, option, { selected }) => (
                    <li {...props} key={option.id}>
                      <Checkbox checked={selected} sx={{ mr: 1 }} />
                      <ListItemText 
                        primary={option.name} 
                        secondary={`ID: ${option.id}`}
                        sx={{ '& .MuiListItemText-secondary': { fontSize: '0.75rem' } }}
                      />
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Estações"
                      placeholder="Digite para pesquisar..."
                    />
                  )}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  noOptionsText="Nenhuma estação encontrada"
                  ListboxProps={{
                    style: { maxHeight: 300 }
                  }}
                  fullWidth
                />
              </CardContent>
            </Card>

            {/* Configuração de Estoque por Estação */}
            {selectedStations.length > 0 && (
              <Box>
                {selectedStations.map((stationId) => {
                  const station = stations.find(s => s.id === stationId);
                  if (!station) return null;
                  const groupings = stationGroupings[stationId] || [];
                  const isExpanded = expandedStations[stationId];

                  return (
                    <Card key={stationId} sx={{ mb: 2 }}>
                      <CardContent>
                        {/* Header da Estação */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                          <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <LocalGasStation />
                            {station.name}
                          </Typography>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <IconButton 
                              size="small" 
                              onClick={() => toggleStationExpand(stationId)}
                              title={isExpanded ? 'Ocultar Agrupamentos' : 'Ver Agrupamentos'}
                            >
                              {isExpanded ? <ExpandLess /> : <ExpandMore />}
                            </IconButton>
                            <IconButton 
                              size="small" 
                              onClick={() => removeStation(stationId)}
                              sx={{ color: 'error.main' }}
                            >
                              <Close />
                            </IconButton>
                          </Box>
                        </Box>

                        {/* Estoque da Estação */}
                        <Typography variant="subtitle2" color="textSecondary" sx={{ mb: 1 }}>
                          Estoque da Estação
                        </Typography>
                        <Grid container spacing={2}>
                          {FUEL_TYPES.map((fuel) => {
                            const inputKey = `${stationId}_${fuel.id}`;
                            const uniqueKey = `${stationId}-${fuel.id}`;
                            return (
                              <Grid item xs={12} sm={6} md={4} key={uniqueKey}>
                                <FuelInput
                                  key={uniqueKey}
                                  stationId={stationId}
                                  fuel={fuel}
                                  initialValue={fuelStock[inputKey]}
                                  onChange={handleStockChange}
                                />
                              </Grid>
                            );
                          })}
                        </Grid>

                        {/* Seção de Agrupamentos (Colapsável) */}
                        <Box 
                          sx={{ 
                            mt: 2, 
                            pt: 2, 
                            borderTop: '1px solid',
                            borderColor: 'divider',
                            cursor: 'pointer'
                          }}
                          onClick={() => toggleStationExpand(stationId)}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <Group color="primary" />
                              <Typography variant="subtitle1" fontWeight="medium">
                                Agrupamentos - Entidades ({groupings.length})
                              </Typography>
                            </Box>
                            {isExpanded ? <ExpandLess /> : <ExpandMore />}
                          </Box>
                        </Box>

                        <Collapse in={isExpanded}>
                          <Box sx={{ mt: 2, pl: 2 }}>
                            {groupings.length === 0 ? (
                              <Typography color="textSecondary" variant="body2">
                                Nenhuma entidade encontrado para esta estação
                              </Typography>
                            ) : (
                              groupings.map((grouping) => {
                                const isGroupingExpanded = expandedGroupings[grouping.id];
                                return (
                                  <Card 
                                    key={grouping.id} 
                                    variant="outlined" 
                                    sx={{ mb: 1, bgcolor: 'grey.50' }}
                                  >
                                    <CardContent sx={{ py: 1, '&:last-child': { pb: 1 } }}>
                                      {/* Header do Grouping */}
                                      <Box 
                                        sx={{ 
                                          display: 'flex', 
                                          alignItems: 'center', 
                                          justifyContent: 'space-between',
                                          cursor: 'pointer'
                                        }}
                                        onClick={() => toggleGroupingExpand(grouping.id)}
                                      >
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                          {grouping.logo_image ? (
                                            <Avatar 
                                              src={grouping.logo_image} 
                                              sx={{ width: 32, height: 32 }}
                                            />
                                          ) : (
                                            <Avatar sx={{ width: 32, height: 32, bgcolor: 'primary.main' }}>
                                              {grouping.name?.charAt(0)?.toUpperCase()}
                                            </Avatar>
                                          )}
                                          <Box>
                                            <Typography variant="body1" fontWeight="medium">
                                              {grouping.name}
                                            </Typography>
                                            {grouping.description && (
                                              <Typography variant="caption" color="textSecondary">
                                                {grouping.description}
                                              </Typography>
                                            )}
                                          </Box>
                                          <Chip 
                                            size="small" 
                                            label={`${grouping.grouping_user?.length || 0} participantes`}
                                            sx={{ ml: 1 }}
                                          />
                                        </Box>
                                        <IconButton size="small">
                                          {isGroupingExpanded ? <ExpandLess /> : <ExpandMore />}
                                        </IconButton>
                                      </Box>

                                      {/* Estoque do Grouping (Colapsável) */}
                                      <Collapse in={isGroupingExpanded}>
                                        <Box sx={{ mt: 2 }}>
                                          <Typography variant="subtitle2" color="textSecondary" sx={{ mb: 1 }}>
                                            Estoque do Agrupamento
                                          </Typography>
                                          <Grid container spacing={2}>
                                            {FUEL_TYPES.map((fuel) => {
                                              const inputKey = `grouping_${grouping.id}_${fuel.id}`;
                                              const uniqueKey = `grouping-${grouping.id}-${fuel.id}`;
                                              return (
                                                <Grid item xs={12} sm={6} md={4} key={uniqueKey}>
                                                  <FuelInput
                                                    key={uniqueKey}
                                                    stationId={`grouping_${grouping.id}`}
                                                    fuel={fuel}
                                                    initialValue={fuelStock[inputKey]}
                                                    onChange={(_, fuelType, value) => 
                                                      handleGroupingStockChange(grouping.id, fuelType, value)
                                                    }
                                                  />
                                                </Grid>
                                              );
                                            })}
                                          </Grid>
                                        </Box>
                                      </Collapse>
                                    </CardContent>
                                  </Card>
                                );
                              })
                            )}
                          </Box>
                        </Collapse>
                      </CardContent>
                    </Card>
                  );
                })}
              </Box>
            )}

            {selectedStations.length === 0 && (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <Typography color="textSecondary">
                  Selecione uma ou mais estações para configurar o estoque de combustível
                </Typography>
              </Box>
            )}
          </TabPanel>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3 }}>
            <SecondaryButton onClick={onClose}>Fechar</SecondaryButton>
          </Box>
        </Box>
      </Dialog>

      {/* Diálogo de Adicionar/Editar Grupo */}
      <Dialog open={addGroupOpen} onClose={() => setAddGroupOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>
          {editingGroupIndex !== null ? 'Editar Grupo de Postos' : 'Adicionar Grupo de Postos'}
        </DialogTitle>
        <DialogContent>
          <TextField
            label="Nome do Grupo"
            value={newGroupName}
            onChange={(e) => setNewGroupName(e.target.value)}
            fullWidth
            margin="dense"
          />
          <FormControl fullWidth margin="dense">
            <InputLabel id="label-posts-multiple">Postos</InputLabel>
            <Select
              labelId="label-posts-multiple"
              multiple
              value={newGroupPosts}
              onChange={(e) => setNewGroupPosts(e.target.value)}
              renderValue={(selected) => selected.join(', ')}
            >
              {posts.map((p, idx) => (
                <MenuItem key={idx} value={p.name}>
                  <Checkbox checked={newGroupPosts.includes(p.name)} />
                  <ListItemText primary={p.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <SecondaryButton onClick={() => setAddGroupOpen(false)}>Cancelar</SecondaryButton>
          <PrimaryButton onClick={confirmGroup}>OK</PrimaryButton>
        </DialogActions>
      </Dialog>

      {/* Diálogo de Adicionar/Editar Rede */}
      <Dialog open={addNetworkOpen} onClose={() => setAddNetworkOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>{editingNetworkIndex !== null ? 'Editar Rede' : 'Adicionar Rede'}</DialogTitle>
        <DialogContent>
          <TextField
            label="Nome da Rede"
            value={newNetworkName}
            onChange={(e) => setNewNetworkName(e.target.value)}
            fullWidth
            margin="dense"
          />
        </DialogContent>
        <DialogActions>
          <SecondaryButton onClick={() => setAddNetworkOpen(false)}>Cancelar</SecondaryButton>
          <PrimaryButton onClick={confirmNetwork}>OK</PrimaryButton>
        </DialogActions>
      </Dialog>

      {/* Diálogo de Adicionar/Editar Posto */}
      <Dialog open={addPostOpen} onClose={() => setAddPostOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{editingPostIndex !== null ? 'Editar Posto' : 'Adicionar Posto'}</DialogTitle>
        <DialogContent>
          <TextField
            label="Nome do Posto"
            value={postName}
            onChange={(e) => setPostName(e.target.value)}
            fullWidth
            margin="dense"
          />
          <FormControl fullWidth margin="dense">
            <InputLabel>Grupo do Posto</InputLabel>
            <Select
              value={postGroup}
              label="Grupo do Posto"
              onChange={(e) => setPostGroup(e.target.value)}
            >
              {groups.map((g, i) => (
                <MenuItem key={i} value={g.name}>
                  {g.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth margin="dense">
            <InputLabel>Rede do Posto</InputLabel>
            <Select
              value={postNetwork}
              label="Rede do Posto"
              onChange={(e) => setPostNetwork(e.target.value)}
            >
              {networks.map((n, i) => (
                <MenuItem key={i} value={n.name || n}>
                  {n.name || n}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
            <TextField
              label="Código Validador"
              value={postCode}
              onChange={(e) => setPostCode(e.target.value)}
              fullWidth
              margin="dense"
            />
            <IconButton size="small" onClick={() => setPostCode(generateCode())} sx={{ mt: '8px' }}>
              <Autorenew />
            </IconButton>
          </Box>
          <TextField
            label="Endereço"
            value={postAddress}
            onChange={(e) => setPostAddress(e.target.value)}
            fullWidth
            margin="dense"
          />
          <FormControl fullWidth margin="dense">
            <InputMask
              mask="99.999.999/9999-99"
              value={postCNPJ}
              onChange={(e) => setPostCNPJ(e.target.value)}
              maskPlaceholder={null}
            >
              {(inputProps) => (
                <TextField
                  {...inputProps}
                  label="CNPJ"
                  placeholder="00.000.000/0000-00"
                  fullWidth
                  margin="dense"
                />
              )}
            </InputMask>
          </FormControl>
          <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
            <TextField
              label="Cidade"
              value={postCity}
              onChange={(e) => setPostCity(e.target.value)}
              fullWidth
              margin="dense"
            />
            <Autocomplete
              options={ESTADOS_BRASILEIROS}
              getOptionLabel={(option) => option ? `${option.sigla} - ${option.nome}` : ''}
              value={ESTADOS_BRASILEIROS.find(e => e.sigla === postState) || null}
              onChange={(event, newValue) => setPostState(newValue ? newValue.sigla : '')}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Estado (UF)"
                  margin="dense"
                  placeholder="Digite para pesquisar..."
                />
              )}
              isOptionEqualToValue={(option, value) => option.sigla === value?.sigla}
              noOptionsText="Nenhum estado encontrado"
              fullWidth
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <SecondaryButton onClick={() => setAddPostOpen(false)}>Cancelar</SecondaryButton>
          <PrimaryButton onClick={confirmPost}>OK</PrimaryButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default connect()(PostosConfigModal);
